// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__UCr_T","head":"ProcedureTableInfo_head__3Ep2k"};